var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_15636_7138)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_15636_7138)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.05469 0.818115H25.8823V17.1818H1.05469V0.818115Z",
  fill: "#EE1C25"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.03324 6.87277L5.70908 2.45459L7.38493 6.87277L2.91602 4.17277H8.50215L4.03324 6.87277Z",
  fill: "#FFFF00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.3028 2.5392L9.5781 2.87507L10.7285 1.697L10.6157 3.28253L9.65861 1.87886L11.3028 2.5392Z",
  fill: "#FFFF00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.044 4.47776L11.3062 4.19952L12.8864 3.50576L12.0827 4.92872L11.82 3.30873L13.044 4.47776Z",
  fill: "#FFFF00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.7898 7.19747L11.3322 6.32053L13.097 6.2535L11.7028 7.26466L12.2148 5.69137L12.7898 7.19747Z",
  fill: "#FFFF00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5976 8.97401L9.6385 7.67037L11.2959 8.20755L9.5654 8.66702L10.7291 7.38959L10.5976 8.97401Z",
  fill: "#FFFF00"
})));
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.96875,
  y: 0.5,
  width: 25,
  height: 17,
  rx: 1.5,
  stroke: "#E0E4E8"
});
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_15636_7138"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1.46875,
  y: 1,
  width: 24,
  height: 16,
  rx: 1,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_15636_7138"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24.8276,
  height: 16.3636,
  fill: "white",
  transform: "translate(1.05469 0.818115)"
})));
function SvgZh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZh);
export default __webpack_public_path__ + "static/media/zh.86f35370.svg";
export { ForwardRef as ReactComponent };